import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import CustomEventCalendar from "./CustomEventCalendar";
import omitDeep from "omit-deep-lodash";
import { uniqueId } from "lodash";
import { getAllData } from "../../../utils/helpers/fetching";
import { GET_BOOKING_ENTRIES_BY_SITE_AND_INVENTORY_ID } from "../../../gql/bookingapi";
import { compose, withApollo } from "react-apollo";
import { connect, useSelector } from "react-redux";
import { CustomFilterContext } from "../../booking-instruments/booking-instruments-custom-filter/context";
import {
  APP_ROUTES,
  ATTRIBUTES_HEADING,
  BACKDROP_ZINDEX,
  CLUSTER_DETAILS_ATTRIBUTE_META,
  CLUSTER_DETAILS_HEADING,
  entryType,
  EQUIPMENT_DETAILS_HEADING,
  EVENT,
  IconStatus,
  NO_EQUIPMENT_FOR_FILTER,
  RESOURCE,
  singleEventSkeleton,
  STANDALONE_ATTRIBUTE_META,
  TIMELINE_BUFFER_UNITS,
} from "../../../constants";
import { loadBookingInstruments as loadBookingInstrumentsAction } from "../../booking-instruments/redux/actions";
import { loadPendingReservations as loadPendingReservationsAction } from "../../booking-calendars/redux/actions";
import { changeDateToUtcString, formatUserDisplay } from "../../../utils/helpers/text";
import { OwcButton } from "@one/react";
import { toast } from "@mobiscroll/react";
import BackdropPortal from "../../../components/shared/BackdropPortal";
import PopOverModal from "../../../components/shared/CommonPopOverModal/PopOverModal";
import useDialog from "../../../utils/hooks/useDialog";
import PopOverClusterAgGridTable from "../../../components/shared/CommonPopOverModal/PopOverClusterAgGridTable";
import PopoverBookingStatusDetail from "../../../components/shared/CommonPopOverModal/PopoverBookingStatusDetail";
import PopoverAttributesDetails from "../../../components/shared/CommonPopOverModal/PopoverAttributesDetails";
import PopoverBookingTitle from "../../../components/shared/CommonPopOverModal/PopoverBookingTitle";
import { BookingContext } from "../../booking/context";
import { PaginationContext } from "../../../components/shared/pagination/PaginationContext";
import { useFormikContext } from "formik";
import { GET_BOOKING_ENTRIES_BY_BOOKING_ID } from "../../../gql/bookingapi/queries";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";
import { getEquipment } from "../../../utils/helpers/fetching";
import { getShortIdentifier } from "@digitallab/grid-common-components";
import ConfirmDialog from "../../../components/shared/ConfirmDialog";
import BookingNotificationStatus from "../../booking-calendars/booking-notification-status/BookingNotificationStatus";
import { DROP_BOOKING } from "../../../gql/bookingapi/mutations";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import { BOOKING_OPERATIONS } from "../../booking-operations";
import { Auth } from "aws-amplify";
import RecurringBookingContext from "./RecurringBooking/Context/RecurringBookingContext";
import { useLocation } from "react-router-dom";
import {
  getAvailableRangesForEquipment,
  getBaseReservationsForEventDetails,
  getQuickEditReservations,
  getReservationDataInRange,
  getUnreservedIntervalsForEventDetails,
  hasValidReservationList,
} from "./getEventDetails.utils";
import {
  getCancelOperationStatus,
  resolveEquipmentListForCalendarRefresh,
} from "./calendarRefresh.utils";

export const filterReservationsForQuickEdit = (baseReservations, pendingModalRefreshRef) => {
  let quickReservations = baseReservations;

  if (pendingModalRefreshRef?.current?.bookingId) {
    const { bookingId, resource } = pendingModalRefreshRef.current;

    quickReservations = baseReservations.filter((x) => {
      const sameBooking =
        x.bookingId === bookingId || x.id === bookingId;
      const sameResource =
        !resource ||
        x.inventoryId === resource ||
        x.resource === resource;

      return sameBooking && sameResource;
    });
  }

  return quickReservations;
};



const CalendarMainPage = ({
  client,
  loadBookingInstruments,
  loadPendingReservations,
  selectedStartDate,
  setSelectedStartDate,
  selectedEndDate,
  setSelectedEndDate,
  tabList,
  setTabList,
  view,
  setView,
  calView,
  setCalView,
  newEquipmentIds,
  setNewEquipmentIds,
  cancelStatus = false,
  setCancelStatus,
  deleteResourceId,
  setDeleteResourceId,
  isEquipmentView = false,
  isTimelineView,
  user: propUser = null,
  setPopupEnableStatus = () => { },
  visibleDatePicker = true,
  signeeFilter = null,
  isGroupView = false,
  listGroupByView,
  setListGroupByView
}) => {
  const formik = useFormikContext();
  const { isEditMode, isDuplicate, isOngoing, editBookingData, dispatchAction: bookingDispatchAction } = useContext(BookingContext);
  const { openDialog, ...dialogProps } = useDialog();
  const [eventsData, setEventsData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [loading, setloading] = useState(false);
  const [selectionType, setSelectionType] = useState();
  const storeUser = useSelector((store) => store.user);
  const user = propUser || storeUser;
  const { pendingReservations } = useSelector((state) => state.reservations);
  const isTvMode = useSelector(state => state?.bookingInstruments?.isTvMode);
  const dataTimeZone = "utc";
  const displayTimeZone = user?.timezone || "UTC";
  const bookingInstruments = useSelector((store) => store.bookingInstruments);
  const usersList = useSelector((state) => state.users.users);
  const { selectedList, setSelectedList } = useContext(CustomFilterContext);
  const [popoverObject, setPopoverObject] = useState({
    equipmentData: {},
    eventData: {},
  });
  const { dispatchAction, data } = useContext(PaginationContext);

  const history = useHistory();

  const [cancelOpen, setCancelOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [isCancelling, setIsCancelling] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [isPopoverFetching, setIsPopoverFetching] = useState(false);
  const [bookingFetchError, setBookingFetchError] = useState(false);
  const pendingModalRefreshRef = useRef(null);
  const [calendarKey, setCalendarKey] = useState(0);
  const cancellationCallbackRef = useRef(null);
  const selectedListBackupRef = useRef(null);
  const isBookingAdmin = user?.roles?.some((role) => role === "BookingAdmin");
  const location = useLocation();
  const {
    isRecurringBooking
  } = useContext(RecurringBookingContext);
  const isRecurringBookingRef = useRef(isRecurringBooking);

  useEffect(() => {
    isRecurringBookingRef.current = isRecurringBooking;
  }, [isRecurringBooking]);

  useEffect(() => {
    const url = `${location.pathname}${location.search || ""}`;
    const shouldResetEdit = (url.includes(APP_ROUTES.MY_BOOKINGS) || url.includes(APP_ROUTES.GROUP_VIEWS)) && isEditMode;
    if (!shouldResetEdit) return;
    bookingDispatchAction({
      type: "editBookingData",
      payload: {
        isEditMode: false,
        editBookingData: null,
        isCreateMode: false,
      },
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const safeSetEventsData = useCallback((newEvents) => {
    if (!Array.isArray(newEvents)) {
      console.warn('CalendarMainPage: safeSetEventsData received non-array data', newEvents);
      return;
    }

    try {
      setEventsData(newEvents);
    } catch (error) {
      console.error('CalendarMainPage: Error setting events data', error);
    }
  }, []);

  useEffect(() => {
    if (isTimelineView) {
      setEventsData([]);
      setSelectedList([]);
      loadPendingReservations([]);
    }
  }, [isTimelineView, setSelectedList, loadPendingReservations, loadBookingInstruments, setNewEquipmentIds]);

  const getExtendedTimelineDates = () => {
    if (!isEditMode && (!selectedStartDate || !selectedEndDate)) {
      return { extendedStartDate: null, extendedEndDate: null };
    }

    const baseStartDate = isEditMode ? editBookingData?.dateFrom : selectedStartDate;
    const baseEndDate = isEditMode ? editBookingData?.dateTo : selectedEndDate;

    if (!baseStartDate || !baseEndDate) {
      return { extendedStartDate: null, extendedEndDate: null };
    }

    let bufferUnits;
    let timeUnit;

    switch (view) {
      case "day":
        bufferUnits = TIMELINE_BUFFER_UNITS.DAY;
        timeUnit = "days";
        break;
      case "week":
        bufferUnits = TIMELINE_BUFFER_UNITS.WEEK;
        timeUnit = "days";
        break;
      case "month":
        bufferUnits = TIMELINE_BUFFER_UNITS.MONTH;
        timeUnit = "months";
        break;
      default:
        bufferUnits = TIMELINE_BUFFER_UNITS.DAY;
        timeUnit = "days";
    }

    const extendedStartDate = moment(baseStartDate).subtract(bufferUnits, timeUnit).toDate();
    const extendedEndDate = moment(baseEndDate).add(bufferUnits, timeUnit).toDate();

    return { extendedStartDate, extendedEndDate };
  };

  const { extendedStartDate, extendedEndDate } = getExtendedTimelineDates();

  const normalizeBookingTitles = (data) => {
    data.forEach((evt) => {
      evt.title = ((evt.type || evt.title) ?? "")
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/^./, (c) => c.toUpperCase());
    });
  };

  useEffect(() => {
    normalizeBookingTitles(eventsData);
  }, [eventsData]);

  useEffect(() => {
    if (pendingReservations.length === 0) {
      tabList[2].isDisable = true;
      setTabList([...tabList]);
    } else if (pendingReservations.length !== 0) {
      tabList[2].isDisable = false;
      setTabList([...tabList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingReservations]);

  useEffect(() => {
    if (bookingInstruments.bookingInstruments.length > 0) {
      const tempResource = [];
      bookingInstruments.bookingInstruments.forEach((item) => {
        tempResource.push({
          name: item.shortIdentifier ? item.shortIdentifier : getShortIdentifier(item),
          id: item?.inventoryId,
          eventOverlap: false,
        });
      });

      tempResource.sort((a, b) => {
        const aName = a.name || "";
        const bName = b.name || "";
        return aName.localeCompare(bName);
      });

      setResourceData(tempResource);
    }
  }, [bookingInstruments.bookingInstruments]);

  // Watch eventsData for changes and update modal if we're waiting for a refresh
  useEffect(() => {
    if (!pendingModalRefreshRef.current || !popoverObject?.eventData?.bookingId) {
      return;
    }

    const { bookingId: targetBookingId, resource: targetResource } = pendingModalRefreshRef.current;

    // Search in the updated eventsData instead of reservationData
    let matchingEntry = null;

    // Strategy 1: Match by bookingId + resource (most reliable)
    if (targetBookingId && targetResource) {
      matchingEntry = eventsData.find(entry =>
        entry.bookingId === targetBookingId &&
        (entry.resource === targetResource || entry.inventoryId === targetResource)
      );
    } else if (targetBookingId) {
      // Strategy 2: Match by bookingId only (fallback when no resource available)
      matchingEntry = eventsData.find(entry => entry.bookingId === targetBookingId);
    }

    if (matchingEntry) {
      setPopoverObject(prev => {
        if (!prev?.eventData) return prev;

        return {
          ...prev,
          eventData: {
            ...prev.eventData,
            id: matchingEntry.id,
            bookingApprovalInfo: matchingEntry.bookingApprovalInfo,
            description: matchingEntry.description,
            project: matchingEntry.project,
            redPandaProjects: matchingEntry.redPandaProjects,
            elnId: matchingEntry.elnId,
            reservedForEmails: matchingEntry.reservedForEmails,
            createdBy: matchingEntry.createdBy,
            createdByEmail: matchingEntry.createdByEmail,
            // Spread bookingApprovalInfo fields to root level (matching the original structure)
            assistent: matchingEntry.bookingApprovalInfo?.assistent,
            assistentTime: matchingEntry.bookingApprovalInfo?.assistentTime,
            approval: matchingEntry.bookingApprovalInfo?.approval,
            checkInDone: matchingEntry.bookingApprovalInfo?.checkInDone,
            checkInRequired: matchingEntry.bookingApprovalInfo?.checkInRequired,
            checkInEndsAt: matchingEntry.bookingApprovalInfo?.checkInEndsAt,
            checkInStartsAt: matchingEntry.bookingApprovalInfo?.checkInStartsAt,
            hazardousDeclaration: matchingEntry.bookingApprovalInfo?.hazardousDeclaration,
            assistanceDeclaration: matchingEntry.bookingApprovalInfo?.assistanceDeclaration
          }
        };
      });

      // Clear the pending refresh flag
      pendingModalRefreshRef.current = null;
    }
  }, [eventsData, popoverObject]);

  const clearPendingReservation = () => {
    loadPendingReservations([]);
  };
  const updatePendingReservation = useCallback((list) => {
    loadPendingReservations([...list]);
  }, [loadPendingReservations]);


  const getBookings = useCallback(async ({ client, siteName, dateFrom, dateTo, equipmentListOverride }) => {
    const effectiveList = equipmentListOverride || selectedList;
    if (!effectiveList || effectiveList.length === 0) {
      return { data: [], hasError: false };
    }

    const tempFilter = {
      or: [],
    };
    effectiveList.forEach((x) => {
      tempFilter.or.push({ inventoryId: { eq: x } });
    });
    let filter = {
      and: [
        { active: { eq: true } },
        {
          or: [{ start: { le: dateTo } }, { end: { ge: dateFrom } }],
        },
      ],
    };

    if (isEditMode && editBookingData?.id) {
      filter.and.push({ bookingId: { ne: editBookingData.id } });
    }

    try {
      const resultArray = [];
      let hasError = false;
      if (isDuplicate && filter.and) {
        filter.and = filter.and.filter(f => !f.bookingId)
      }
      await Promise.all(
        effectiveList.map(async (k) => {
          try {
            const { items, error } = await getAllData({
              client,
              query: GET_BOOKING_ENTRIES_BY_SITE_AND_INVENTORY_ID,
              drillData: true,
              fetchPolicy: "no-cache",
              variables: {
                inventoryId: { eq: k },
                limit: 1000,
                nextToken: null,
                site: siteName,
                filter: filter,
              },
              dataPath: ["data", "bookingEntriesBySiteAndInventoryId"],
              isTvMode
            });
            if (error) {
              hasError = true;
              return [];
            }
            const result = omitDeep(items || [], "recurring").filter((x) => x && x.start < x.end);
            resultArray.push(...result);
            return items;
          } catch (itemError) {
            hasError = true;
            return [];
          }
        })
      );
      if (hasError) {
        return { data: [], hasError: true };
      }
      if (signeeFilter && signeeFilter.username !== "") {
        return {
          data: resultArray.filter((result) => {
            return result.reservedForEmails.includes(signeeFilter.email);
          }),
          hasError: false
        };
      }
      return { data: resultArray, hasError: false };
    } catch (e) {
      return { data: [], hasError: true };
    }
  }, [selectedList, isEditMode, editBookingData, isDuplicate, signeeFilter, isTvMode]);

  const getReservationBooking = useCallback(async (dateFrom, dateTo, equipmentListOverride) => {
    try {
      const result = await getBookings({
        client,
        siteName: user?.site,
        dateFrom,
        dateTo,
        equipmentListOverride,
      });

      if (result.hasError) {
        setBookingFetchError(true);
        snackbarService.show({ message: "Unexpected Server Error", type: "error" });
        return result;
      }

      setBookingFetchError(false);
      const reservationData = result.data;

      if (!reservationData || !Array.isArray(reservationData)) {
        return { data: [], hasError: false };
      }

      reservationData.forEach((item) => {
        if (item) {
          item["editable"] = false;
          item["title"] = item?.type;
        }
      });
      return { data: reservationData, hasError: false };
    } catch (error) {
      setBookingFetchError(true);
      snackbarService.show({ message: "Unexpected Server Error", type: "error" });
      return { data: [], hasError: true };
    }
  }, [getBookings, client, user]);

  // Helper: Create a base interval row with optional edit mode styling
  const createIntervalRow = useCallback((start, end, resource, intervalRowConfiguration) => {
    let row = {
      ...singleEventSkeleton,
      id: uniqueId("available_"),
      start,
      end,
      resource,
    };

    if (isEditMode && intervalRowConfiguration) {
      row = {
        ...row,
        type: formik?.values?.bookingType,
        color: intervalRowConfiguration.backgroundColor,
        fcolor: intervalRowConfiguration.color,
        title: formik?.values?.bookingType,
      };
    }

    return row;
  }, [isEditMode, formik?.values?.bookingType]);

  // Helper: Get interval row configuration for edit mode
  const getIntervalRowConfiguration = useCallback(() => {
    if (!isEditMode) return null;
    const row = IconStatus.find((x) => x.text === formik?.values?.bookingType);
    return row ?? null;
  }, [isEditMode, formik?.values?.bookingType]);

  // Helper: Get original equipment IDs from booking in edit mode
  const getOriginalEquipmentIds = useCallback(() => {
    if (!isEditMode || !editBookingData?.bookingEntries) return [];
    return editBookingData.bookingEntries.map((entry) => entry.inventoryId);
  }, [isEditMode, editBookingData]);

  // Helper: Check if equipment should be processed (skip newly added equipment in edit mode)
  const shouldProcessEquipment = useCallback((item, originalEquipmentIds, includeNewEquipmentInEditMode = false) => {
    if (includeNewEquipmentInEditMode) return true;
    // istanbul ignore next - Covered by CalendarMainPage.test.js simulation tests
    return !isEditMode || originalEquipmentIds.includes(item);
  }, [isEditMode]);

  // Helper: Create intervals for equipment without reservations
  const createIntervalsForUnreservedEquipment = useCallback((
    activeEquipmentList,
    reservationData,
    startRange,
    endRange,
    originalEquipmentIds,
    intervalRowConfiguration,
    includeNewEquipmentInEditMode = false,
  ) => {
    const intervals = [];

    activeEquipmentList.forEach((item) => {
      // istanbul ignore next - Covered by CalendarMainPage.test.js simulation tests
      if (!shouldProcessEquipment(item, originalEquipmentIds, includeNewEquipmentInEditMode)) return;

      const availableRanges = getAvailableRangesForEquipment({
        reservationData,
        equipmentId: item,
        startRange,
        endRange,
      });

      availableRanges.forEach((range) => {
        intervals.push(createIntervalRow(range.start, range.end, item, intervalRowConfiguration));
      });
    });

    return intervals;
  }, [shouldProcessEquipment, createIntervalRow]);

  // Helper: Update state with computed intervals
  const updateStateWithIntervals = useCallback((reservationList, tempInterval, onGoingEventList) => {
    if (!Array.isArray(reservationList) || !Array.isArray(tempInterval)) {
      console.error('CalendarMainPage: Invalid data structure for setEventsData', {
        reservationList,
        tempInterval
      });
      return;
    }

    safeSetEventsData([...reservationList, ...tempInterval]);

    if (isEditMode && isOngoing) {
      loadPendingReservations([...onGoingEventList, ...tempInterval]);
    } else {
      loadPendingReservations([...tempInterval]);
    }
  }, [safeSetEventsData, loadPendingReservations, isEditMode, isOngoing]);

  // isRecurringBooking is used in this function to allow for overlapping events when recurring booking is created by user.
  // Recurring bookings with conflicts (overlap) are blocked from being saved.
  // Single (non-recurring) bookings should be handled as usual. RETINA-5685174
  const getEventDetails = useCallback(({
    startDate,
    endDate,
    reservationList = [],
    onGoingEventList = [],
    equipmentListOverride = null,
    isQuickEdit = false,
    includeNewEquipmentInEditMode = false,
  } = {}) => {
    // Handle case when no date range is provided
    if (!startDate || !endDate) {
      if (!hasValidReservationList(reservationList)) {
        console.error('CalendarMainPage: Invalid reservationList for setEventsData (no dates)', { reservationList });
        return;
      }

      safeSetEventsData([...reservationList]);
      updatePendingReservation([]);
      return;
    }

    const currentIsRecurring = isRecurringBookingRef.current;
    const startRange = changeDateToUtcString(startDate);
    const endRange = changeDateToUtcString(endDate);

    const normalizedReservationList = reservationList || [];
    const reservationData = getReservationDataInRange({
      reservationList: normalizedReservationList,
      startRange,
      endRange,
      currentIsRecurring,
    });
    const baseReservations = getBaseReservationsForEventDetails({
      reservationList: normalizedReservationList,
      reservationData,
      currentIsRecurring,
    });

    if (isQuickEdit) {
      const quickReservations = getQuickEditReservations({
        baseReservations,
        refreshTarget: pendingModalRefreshRef.current,
      });

      updateStateWithIntervals(quickReservations, [], onGoingEventList);
      return;
    }

    const activeEquipmentList = equipmentListOverride || selectedList;
    const originalEquipmentIds = getOriginalEquipmentIds();
    const intervalRowConfiguration = getIntervalRowConfiguration();

    const unreservedIntervals = getUnreservedIntervalsForEventDetails({
      isTimelineView,
      createIntervalsForUnreservedEquipment,
      activeEquipmentList,
      reservationData,
      startRange,
      endRange,
      originalEquipmentIds,
      intervalRowConfiguration,
      includeNewEquipmentInEditMode,
    });

    updateStateWithIntervals(reservationList, unreservedIntervals, onGoingEventList);
  }, [
    selectedList,
    safeSetEventsData,
    updatePendingReservation,
    getOriginalEquipmentIds,
    getIntervalRowConfiguration,
    createIntervalsForUnreservedEquipment,
    updateStateWithIntervals,
    isTimelineView
  ]);

  const getLatestEventDetailsOnly = (startDate, endDate, reservationList, newSelectedList = []) => {
    if (!startDate || !endDate) return;

    const startRange = changeDateToUtcString(startDate);
    const endRange = changeDateToUtcString(endDate);
    const latestSelectedList = newSelectedList.filter((x) => selectedList.indexOf(x) !== -1);

    // No equipment to process - just update state with existing data
    if (latestSelectedList.length === 0) {
      safeSetEventsData([...reservationList, ...pendingReservations]);
      return;
    }

    const originalEquipmentIds = getOriginalEquipmentIds();
    const intervalRowConfiguration = getIntervalRowConfiguration();

    // Filter reservations to only include those for the selected equipment
    const filteredReservationList = reservationList.filter(
      (x) => latestSelectedList.indexOf(x.resource) !== -1
    );

    // Get reservations within the date range
    const baseReservationData = filteredReservationList.filter(
      (x) => x.end >= startRange && x.start <= endRange
    );
    const pendingInRange = pendingReservations.filter(
      (x) => x.end >= startRange && x.start <= endRange && latestSelectedList.indexOf(x.resource) !== -1
    );
    const reservationData = [...baseReservationData, ...pendingInRange];

    // Create intervals for equipment without reservations
    const unreservedIntervals = createIntervalsForUnreservedEquipment(
      latestSelectedList,
      reservationData,
      startRange,
      endRange,
      originalEquipmentIds,
      intervalRowConfiguration
    );

    safeSetEventsData([...reservationList, ...unreservedIntervals, ...pendingReservations]);
    loadPendingReservations([...pendingReservations, ...unreservedIntervals]);
  };

  const removeEquipmentAndReservation = (resourceId, pendingReservationsList) => {
    const tempEventData = eventsData.filter((x) => x.resource !== resourceId);
    const tempResourceData = resourceData.filter((x) => x.id !== resourceId);
    safeSetEventsData(tempEventData);
    setResourceData(tempResourceData);
    setSelectedList(selectedList.filter((x) => x !== resourceId));
    updatePendingReservation(pendingReservationsList.filter((x) => x.resource !== resourceId));
    loadBookingInstruments({
      bookingInstruments: bookingInstruments.bookingInstruments.filter((x) => x.inventoryId !== resourceId),
    });
  };

  const manipulatePopoverContent = async ({ userSelectionType, resourceId = null, eventId = null }) => {
    setSelectionType(userSelectionType);

    if (selectedList && selectedList.length > 0) {
      selectedListBackupRef.current = [...selectedList];
    }

    switch (userSelectionType) {
      case EVENT:
        if (eventId) {
          const eventData = eventsData.find((x) => x.id === eventId);
          if (!eventData) return;

          setIsPopoverFetching(true);
          try {
            const equipmentData = await getEquipment({
              inventoryId: eventData.resource,
              client,
            });

            if (!equipmentData) return;

            const relatedEntries = Array.isArray(eventsData)
              ? eventsData.filter(e => e?.bookingId && e.bookingId === eventData.bookingId)
              : [];
            const bookedEquipments = Array.from(new Set(
              relatedEntries.map(e => (e?.equipment?.shortIdentifier || e?.resource)).filter(Boolean)
            ));

            const finalEventData = {
              ...eventData,
              bookingEntries: relatedEntries,
              ...eventData.bookingApprovalInfo
            };

            openDialog();
            setPopoverObject({
              equipmentData: { ...equipmentData, bookedEquipments },
              eventData: finalEventData,
            });
          } catch (error) {
            console.error("Error fetching equipment data:", error);
          } finally {
            setIsPopoverFetching(false);
          }
        }
        break;

      case RESOURCE:
        if (resourceId) {
          setIsPopoverFetching(true);
          try {
            const equipmentData = await getEquipment({
              inventoryId: resourceId,
              client,
            });

            if (!equipmentData) return;

            openDialog();
            setPopoverObject({
              equipmentData: equipmentData,
              eventData: {},
            });
          } catch (error) {
            console.error("Error fetching equipment data:", error);
          } finally {
            setIsPopoverFetching(false);
          }
        }
        break;

      default:
        break;
    }
  };

  const emailToBookingForObj = (email) => {
    const found = usersList.find((u) => u.email === email);
    return found ? {
      ...found,
      key: found.email,
      value: formatUserDisplay(found),
    } : {
      key: email,
      userId: null,
      email,
      name: email,
      givenName: "",
      familyName: "",
      value: email,
    };
  };

  const editBooking = async (editData) => {
    let editDataClone = eventsData.find((x) => x.bookingId === editData.bookingId);

    editDataClone["bookedEquipments"] = [editDataClone.equipment?.shortIdentifier];
    editDataClone["dateFrom"] = editDataClone.start;
    editDataClone["dateTo"] = editDataClone.end;
    editDataClone.id = editDataClone.bookingId;

    const extraFieldsToRemove = [
      "allDay",
      "color",
      "editable",
      "createdAt",
      "end",
      "expiresAt",
      "fcolor",
      "recurringException",
      "recurringExceptionRule",
      "resource",
      "site",
      "start",
      "timezone",
      "title",
    ];
    extraFieldsToRemove.forEach((k) => delete editDataClone[k]);

    const currentTimeString = moment.tz(user.timezone).utc().format();
    dispatchAction({
      type: "fetching",
      payload: true,
    });

    const { items } = await getAllData({
      client,
      query: GET_BOOKING_ENTRIES_BY_BOOKING_ID,
      drillData: true,
      fetchPolicy: "no-cache",
      variables: {
        bookingId: editDataClone.bookingId,
        nextToken: null,
        filter: { active: { eq: true } },
      },
      dataPath: ["data", "bookingEntriesByBookingId"],
    });
    if (items.length > 0) {
      const keyArray = Object.keys(singleEventSkeleton);
      editDataClone["bookingEntries"] = items.map((item) => {
        if (new Date(item.start) < new Date(editDataClone["dateFrom"])) {
          editDataClone["dateFrom"] = item.start;
        }
        if (new Date(item.end) > new Date(editDataClone["dateTo"])) {
          editDataClone["dateTo"] = item.end;
        }
        let tempObj = {};
        keyArray.forEach((key) => {
          tempObj = {
            ...tempObj,
            [key]: item[key] ?? null,
          };
        });
        tempObj = {
          ...tempObj,
          inventoryId: item.resource,
          equipment: item.equipment,
          title: item.type,
          description: item?.description,
          elnId: item?.elnId,
          project: item?.project,
          redPandaProjects: item?.redPandaProjects,
          createdBy: item?.createdBy,
          reservedForEmails: item?.reservedForEmails,
        };
        return tempObj;
      });
      const bookedUsersList = (editDataClone.reservedForEmails || []).map(emailToBookingForObj);
      editDataClone.bookingFor = bookedUsersList;
      editDataClone.bookedUsers = bookedUsersList;
      if (items[0].elnId) editDataClone.elnId = items[0].elnId;
    }
    bookingDispatchAction({
      type: "editBookingData",
      payload: {
        isEditMode: true,
        editBookingData: editDataClone,
        isOngoing: currentTimeString > editDataClone.dateFrom && currentTimeString < editDataClone.dateTo,
      },
    });

    const tempBookingEntries = editDataClone?.bookingEntries.map((item) => {
      return {
        ...item,
        inventoryId: item.resource,
        isEditEventFlag: true,
        isOngoingEventFlag:
          (currentTimeString > item.end && currentTimeString > item.start) ||
          (currentTimeString > item.start && currentTimeString < item.end),
        editable: currentTimeString < item.end,
        title: item?.type,
      };
    });
    loadPendingReservations(tempBookingEntries);
    if (data) history.push("/");
  };

  const buildEntryFromSkeleton = useCallback((item, skeletonKeys) => {
    const entry = {};
    skeletonKeys.forEach((k) => {
      entry[k] = item[k] ?? null;
    });
    return entry;
  }, []);

  const resolveBookingEntryEquipment = useCallback((item, equipmentDetailsMap) => {
    const fetched = equipmentDetailsMap.get(item.resource);
    if (fetched) {
      return {
        ...fetched,
        id: fetched.inventoryId || item.resource,
      };
    }

    const fallbackIdentifier = item.equipment?.shortIdentifier || item.resource;
    const fallbackModel = item.equipment?.equipmentModel || fallbackIdentifier;
    return item.equipment ?? {
      id: item.resource,
      shortIdentifier: fallbackIdentifier,
      equipmentModel: fallbackModel,
    };
  }, []);

  const buildBookingEntry = useCallback((item, skeletonKeys, equipmentDetailsMap) => {
    const baseEntry = buildEntryFromSkeleton(item, skeletonKeys);

    return {
      ...baseEntry,
      inventoryId: item.resource,
      equipment: resolveBookingEntryEquipment(item, equipmentDetailsMap),
      title: item.type,
      description: item.description ?? null,
      elnId: item.elnId ?? null,
      project: item.project ?? null,
      createdBy: item.createdBy ?? user?.user,
      reservedForEmails: item.reservedForEmails?.length > 0 ? item.reservedForEmails : [user?.email],
    };
  }, [buildEntryFromSkeleton, resolveBookingEntryEquipment, user?.email, user?.user]);

  // Create a new booking draft from pending reservations and navigate to home (step 2 prefilled)
  // Ensures complete equipment information is fetched, including hazardous material flags
  const handleCreateBookingFromEquipmentView = useCallback(async () => {
    try {

      if (!pendingReservations || pendingReservations.length === 0) {
        toast({ message: "Create time slots first" });
        return;
      }

      // Compute overall date range
      const starts = pendingReservations.map((r) => new Date(r.start)).filter(Boolean);
      const ends = pendingReservations.map((r) => new Date(r.end)).filter(Boolean);
      const dateFrom = starts.length ? new Date(Math.min.apply(null, starts)).toISOString() : null;
      const dateTo = ends.length ? new Date(Math.max.apply(null, ends)).toISOString() : null;

      // Unique equipment inventory IDs
      const equipmentIds = Array.from(
        new Set(
          pendingReservations
            .map((r) => r.resource)
            .filter((id) => !!id)
        )
      );

      // Fetch equipment details for richer display (equipmentModel, serialNumber, shortIdentifier, isHazardous)
      const equipmentDetailsMap = new Map();
      try {
        await Promise.all(
          equipmentIds.map(async (inventoryId) => {
            const eq = await getEquipment({
              inventoryId,
              client
            });
            if (eq) {
              equipmentDetailsMap.set(inventoryId, eq);
            }
          })
        );

      } catch (e) {
        console.error('Equipment details fetch failed, using fallbacks');
      }

      // Build bookingEntries based on singleEventSkeleton keys
      const skeletonKeys = Object.keys(singleEventSkeleton);
      const bookingEntries = pendingReservations.map((item) =>
        buildBookingEntry(item, skeletonKeys, equipmentDetailsMap)
      );

      const draftBookingData = {
        // Identify this as a draft without bookingId
        id: undefined,
        bookingEntries,
        bookedEquipments: equipmentIds,
        dateFrom,
        dateTo,
        site: user?.site,
        type: null,
        description: "",
        project: "",
        redPandaProjects: [],
        createdBy: user,
        reservedForEmails: [user?.email],
        reservedForUsers: [user?.user],
        bookingFor: [{
          ...user,
          key: user?.email,
          value: formatUserDisplay(user),
        }],
        bookedUsers: [{
          ...user,
          key: user?.email,
          value: formatUserDisplay(user),
        }],
      };

      // Seed step 2 by (temporarily) using edit mode to pass preSelectedList via context
      bookingDispatchAction({
        type: "editBookingData",
        payload: {
          isEditMode: true,
          editBookingData: draftBookingData,
          isCreateMode: true,
          isOngoing: false,
          startAtStep: 3,
        },
      });

      // Persist pending reservations via redux
      updatePendingReservation([...pendingReservations]);

      // Navigate to home where BookEquipment flow is mounted
      history.push("/");

      // Do not flip isEditMode here; it will be reset in BookEquipmentMainPage after mount to avoid memory leaks
    } catch (e) {
      toast({ message: "Unable to start booking creation" });
    }
  }, [pendingReservations, user, updatePendingReservation, bookingDispatchAction, history, client, buildBookingEntry]);

  const resetCancelState = useCallback(() => {
    setCancelOpen(false);
    setIsCancelling(false);
    setCancelReason("");
  }, []);

  const resolveEquipmentList = useCallback(() => {
    const { equipmentList, shouldPersistSelection } =
      resolveEquipmentListForCalendarRefresh({
        selectedList,
        backupSelectedList: selectedListBackupRef.current || [],
        bookingInstruments: bookingInstruments.bookingInstruments || [],
      });

    if (shouldPersistSelection) {
      setSelectedList(equipmentList);
    }

    return equipmentList;
  }, [bookingInstruments.bookingInstruments, selectedList, setSelectedList]);

  const handleCancelSuccess = useCallback(async () => {
    try {
      const equipmentList = resolveEquipmentList();
      const reservationResult = await getReservationBooking(
        changeDateToUtcString(extendedStartDate),
        changeDateToUtcString(extendedEndDate),
        equipmentList,
      );

      if (reservationResult.hasError) {
        setBookingFetchError(true);
        resetCancelState();
        return;
      }

      getEventDetails({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        reservationList: reservationResult.data || [],
        onGoingEventList: [],
        equipmentListOverride: equipmentList,
      });

      setCalendarKey((prev) => prev + 1);
      setTimeout(resetCancelState, 300);
    } catch (error) {
      console.error("Error refreshing data after cancellation:", error);
      resetCancelState();
    }
  }, [
    extendedEndDate,
    extendedStartDate,
    getEventDetails,
    getReservationBooking,
    resetCancelState,
    resolveEquipmentList,
    selectedEndDate,
    selectedStartDate,
  ]);

  const bookingCallback = useCallback(
    async (response) => {
      const { isCancelSuccess, isCancelFailure } = getCancelOperationStatus({
        response,
        cancelOperation: BOOKING_OPERATIONS.CANCEL,
      });

      if (isCancelSuccess) {
        await handleCancelSuccess();
        return;
      }

      if (isCancelFailure) {
        setIsCancelling(false);
        setCancelReason("");
        try {
          snackbarService.show({
            type: "error",
            message: "Failed to cancel booking",
            duration: 3000,
          });
        } catch (_) {}
      }
    },
    [handleCancelSuccess],
  );

  const handleCancelBooking = async () => {
    const eventData = popoverObject?.eventData;
    const bookingId = eventData?.bookingId || eventData?.id;
    if (!bookingId || !cancelReason) return;

    setIsCancelling(true);

    cancellationCallbackRef.current = async () => {
      await bookingCallback({ operation: BOOKING_OPERATIONS.CANCEL, success: true });
      dialogProps.close();
      setPopoverObject({});
    };

    try {
      const { username: id } = await Auth.currentAuthenticatedUser();
      await client.mutate({
        mutation: DROP_BOOKING,
        variables: {
          createdBy: id,
          bookingId,
          remark: cancelReason,
          ...(storeUser?.roles?.includes("BookingAdmin") ? { force: true } : {})
        },
      });
    } catch (error) {
      console.error("Error cancelling booking:", error);
      cancellationCallbackRef.current = null;
      setCancelReason("");
      try {
        snackbarService.show({ type: 'error', message: 'Cancellation failed', duration: 3000 });
      } catch (_) { }
      setIsCancelling(false);
    }
  };

  const displayCancelBookingButton = () => {
    if (!isTimelineView) return null;

    const eventData = popoverObject?.eventData;
    if (!eventData || Object.keys(eventData).length === 0) return null;

    const isBookingAdmin = storeUser?.roles?.some((role) => role === "BookingAdmin");
    const isCreator = eventData?.createdBy === storeUser?.user;
    const isBookedForUser = eventData?.reservedForEmails?.includes(storeUser?.email);

    if (isBookingAdmin || isCreator || isBookedForUser) {
      return (
        <OwcButton
          variant="secondary"
          flat={true}
          style={{ marginLeft: "20px" }}
          onClick={() => setCancelOpen(true)}
        >
          Cancel Booking
        </OwcButton>
      );
    }

    return null;
  };

  const setPendingModalRefresh = useCallback(() => {
    const bookingIdToRefresh = popoverObject?.eventData?.bookingId;
    if (!bookingIdToRefresh) return;

    const resourceToRefresh = popoverObject.eventData.resource || popoverObject.eventData.inventoryId;
    pendingModalRefreshRef.current = {
      bookingId: bookingIdToRefresh,
      resource: resourceToRefresh,
    };
  }, [popoverObject]);

  const handleQuickEditComplete = useCallback(async () => {
    try {
      setPendingModalRefresh();

      const equipmentList = resolveEquipmentList();

      const reservationResult = await getReservationBooking(
        changeDateToUtcString(extendedStartDate),
        changeDateToUtcString(extendedEndDate),
        equipmentList,
      );

      if (reservationResult.hasError) {
        setBookingFetchError(true);
        pendingModalRefreshRef.current = null;
        return;
      }

      const reservationData = reservationResult.data;

      getEventDetails({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        reservationList: reservationData || [],
        onGoingEventList: [],
        equipmentListOverride: equipmentList,
        isQuickEdit: true,
      });

      setCalendarKey(prev => prev + 1);
    } catch (error) {
      console.error("Error refreshing data after quick edit:", error);
      snackbarService.show({ type: 'error', message: 'Failed to refresh calendar', duration: 3000 });
      pendingModalRefreshRef.current = null;
    }
  }, [
    extendedStartDate,
    extendedEndDate,
    getEventDetails,
    getReservationBooking,
    resolveEquipmentList,
    selectedEndDate,
    selectedStartDate,
    setPendingModalRefresh,
  ]);

  const displayEditFunctionality = () => {
    if (!isTimelineView) return null;

    const eventData = popoverObject?.eventData;
    if (!eventData || Object.keys(eventData).length === 0) return null;

    const isBookingAdmin = storeUser?.roles?.some((role) => role === "BookingAdmin");
    const isCreator = eventData?.createdBy === storeUser?.user;
    const isBookedForUser = eventData?.reservedForEmails?.includes(storeUser?.email);

    if (isBookingAdmin || isCreator || isBookedForUser) {
      return (
        <div style={{ display: "flex" }}>
          {displayCancelBookingButton()}
          <OwcButton
            variant="primary"
            style={{ marginLeft: "20px" }}
            onClick={() => {
              setPopupEnableStatus(true);
              editBooking(eventData);
            }}
          >
            Open Full Edit
          </OwcButton>
        </div>
      );
    }

    return null;
  };

  const showStatus = loading || popupLoading || isCancelling || isPopoverFetching

  const resourcePopoverData = useMemo(
    () => ({ ...popoverObject?.equipmentData, context: popoverObject }),
    [popoverObject]
  )

  const eventPopoverData = useMemo(
    () => ({
      ...popoverObject?.equipmentData,
      context: popoverObject?.eventData,
      bookingEntries: popoverObject?.eventData?.bookingEntries,
    }),
    [popoverObject?.equipmentData, popoverObject?.eventData]
  )

  return (
    <>
      <BackdropPortal
        show={showStatus}
        zIndex={BACKDROP_ZINDEX + (popupLoading || isCancelling ? 10 : 0)}
      />
      {isCancelling && (
        <BookingNotificationStatus onBookingCallback={cancellationCallbackRef.current} />
      )}
      {bookingInstruments.bookingInstruments.length > 0 ? (
        <CustomEventCalendar
          key={calendarKey}
          eventData={eventsData}
          resourceData={resourceData}
          selectedStartDate={extendedStartDate}
          setSelectedStartDate={setSelectedStartDate}
          selectedEndDate={extendedEndDate}
          setSelectedEndDate={setSelectedEndDate}
          originalSelectedStartDate={selectedStartDate}
          originalSelectedEndDate={selectedEndDate}
          setEventsData={setEventsData}
          setResourceData={setResourceData}
          dataTimeZone={dataTimeZone}
          displayTimeZone={displayTimeZone}
          getReservationBooking={getReservationBooking}
          clearPendingReservation={clearPendingReservation}
          updatePendingReservation={updatePendingReservation}
          removeEquipmentAndReservation={removeEquipmentAndReservation}
          pendingReservations={pendingReservations}
          getEventDetails={getEventDetails}
          setloading={setloading}
          loading={loading}
          view={view}
          setView={setView}
          calView={calView}
          setCalView={setCalView}
          siteTimezone={user.timezone}
          manipulatePopoverContent={manipulatePopoverContent}
          newEquipmentIds={newEquipmentIds}
          setNewEquipmentIds={setNewEquipmentIds}
          getLatestEventDetailsOnly={getLatestEventDetailsOnly}
          setCancelStatus={setCancelStatus}
          cancelStatus={cancelStatus}
          deleteResourceId={deleteResourceId}
          setDeleteResourceId={setDeleteResourceId}
          isEquipmentView={isEquipmentView}
          isTimelineView={isTimelineView}
          user={user}
          client={client}
          visibleDatePicker={visibleDatePicker}
          isGroupView={isGroupView}
          handleCreateBookingFromEquipmentView={handleCreateBookingFromEquipmentView}
          listGroupByView={listGroupByView}
          setListGroupByView={setListGroupByView}
          bookingFetchError={bookingFetchError}
        />
      ) : (
        isTimelineView && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 16px",
              marginTop: "20px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <span
              style={{
                backgroundColor: "#fefde1",
                border: "1px solid #ccc",
                padding: "8px 12px",
                borderRadius: "2px",
                fontSize: "14px",
              }}
            >
              {NO_EQUIPMENT_FOR_FILTER}
            </span>
          </div>
        )
      )}
      <PopOverModal
        title={
          selectionType === RESOURCE
            ? popoverObject?.equipmentData?.shortIdentifier
            : popoverObject?.equipmentData &&
            Object.keys(popoverObject.equipmentData).length > 0 && <PopoverBookingTitle data={popoverObject} />
        }
        closeTitle="Close"
        data={popoverObject}
        {...dialogProps}
        onDialogCloseCallBack={() =>
          setPopoverObject({
            equipmentData: {},
            eventData: {},
          })
        }
        showEmailButton={!isTimelineView}
        actions={displayEditFunctionality()}
      >
        {selectionType === RESOURCE && (
          <PopoverAttributesDetails
            title={ATTRIBUTES_HEADING}
            metaData={
              popoverObject?.equipmentData?.entryType === entryType.cluster
                ? CLUSTER_DETAILS_ATTRIBUTE_META
                : STANDALONE_ATTRIBUTE_META
            }
            data={resourcePopoverData}
          />
        )}
        {selectionType === EVENT && (
          <>
            <PopoverBookingStatusDetail
              data={{
                eventData: {
                  ...popoverObject?.eventData,
                  ...popoverObject?.eventData?.bookingApprovalInfo
                },
              }}
              allowAssistanceEdit={isBookingAdmin}
              startLoading={() => setPopupLoading(true)}
              stopLoading={() => setPopupLoading(false)}
              onUpdateComplete={handleQuickEditComplete}
              onAssistanceUpdateComplete={handleQuickEditComplete}
            />

            <PopoverAttributesDetails
              title={
                popoverObject?.equipmentData?.entryType === entryType.cluster
                  ? CLUSTER_DETAILS_HEADING
                  : EQUIPMENT_DETAILS_HEADING
              }
              metaData={
                popoverObject?.equipmentData?.entryType === entryType.cluster
                  ? CLUSTER_DETAILS_ATTRIBUTE_META
                  : STANDALONE_ATTRIBUTE_META
              }
              data={eventPopoverData}
            />
          </>
        )}
        {popoverObject?.equipmentData?.entryType === entryType.cluster && (
          <PopOverClusterAgGridTable data={[popoverObject?.equipmentData]} />
        )}
      </PopOverModal>

      <ConfirmDialog
        open={cancelOpen}
        close={() => setCancelOpen(false)}
        title="Cancel booking"
        content={`Please add reason for canceling booking`}
        approveText="Drop booking"
        cancelText="Close"
        showReasonDD={true}
        reasonValue={cancelReason}
        onReasonChanged={(r) => setCancelReason(r)}
        disableBooking={!cancelReason || isCancelling}
        onApprove={handleCancelBooking}
      />
    </>
  );
};

export default compose(
  connect(null, {
    loadBookingInstruments: loadBookingInstrumentsAction,
    loadPendingReservations: loadPendingReservationsAction,
  }),
  withApollo
)(CalendarMainPage);
